/**
 * The words figure S4's "Shared with you" chip puts on the screen, and the one
 * rule about naming a person: prefer a served display name, fall back to the
 * local part of their email, NEVER a raw id.
 *
 * Separate from the component so both can be tested directly, and so the
 * component file exports only a component.
 */
/** The wording the figure uses for each level, in plain words. */
export const PERMISSION_WORD: Record<string, string> = {
  view: 'View',
  comment: 'Comment',
  edit: 'Edit',
  manager: 'Manager',
  admin: 'Admin',
}

/**
 * A person's name for the chip. Prefers a served display name; falls back to
 * the local part of their email, which is the only other human-readable thing
 * the owners route carries. NEVER a raw id — an id tells the reader nothing and
 * is not a name.
 */
// `name` may be null as well as absent — the owners route sends null when the
// pool holds no name. Both mean the same thing: fall back to the email's local
// part, never to an id.
export function sharerLabel(
  owner: { email?: string | null; name?: string | null } | undefined,
): string | null {
  const name = owner?.name?.trim()
  if (name) return name
  const email = owner?.email?.trim()
  if (!email || !email.includes('@')) return null
  return email.split('@')[0]
}
